import React from 'react';
import PropTypes from 'prop-types';

var NavDrawerGroup = function NavDrawerGroup(_ref) {
  var children = _ref.children,
      name = _ref.name;

  if (children) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "paddingleft-xl paddingright-xl paddingtop-md paddingbottom-md"
    }, /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("ul", {
      className: "navdrawer__ul navdrawer__ul--first-child",
      role: "menu"
    }, children, name));
  } else {
    return null;
  }
};

NavDrawerGroup.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string
};
NavDrawerGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NavDrawerGroup",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default NavDrawerGroup;